import { observer } from 'mobx-react-lite';
import { SVGPureIcon } from '@ui/svg-icon';
import { Tooltip } from 'antd' 
import { useState, useRef, useEffect } from 'react';

import "./index.scss"

const MMDownload = observer((props = {}) => {
    const { 
        download = () => {},
        className = ""
    } = props
    const mmDownloadRef = useRef(null);
    const [showTip, setShowTip] = useState(false)
    const [open, setOpen] = useState(false)

    const downloadFile = (type="png") => {
        download(type)
        setShowTip(false)
    }

    const handleClickOutside = (event) => {
        if (mmDownloadRef?.current && !mmDownloadRef?.current?.contains(event?.target)) {
            setShowTip(false)
            setOpen(false)
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    return (
        <div className={["mm-download", className]} ref={mmDownloadRef}>
            {
                showTip 
                ? <div className='downloads'>
                    <div className="download" onClick={() => { downloadFile("png")}}>
                        下载原图
                    </div>
                    <div className="download" onClick={() => { downloadFile("xmind")}}>
                        下载.xmind格式
                    </div>
                </div>
                : null
            }
            <Tooltip title={"下载"} destroyTooltipOnHide open={open}>
                <button onClick={() => { 
                    setShowTip(!showTip) 
                    setOpen(!open)
                }}
                    onMouseEnter={() => { !showTip && setOpen(true) }}
                    onMouseLeave={() => { !showTip && setOpen(false) }}
                    className="rounded-7px p-[2px] hover:bg-[rgba(0,0,0,0.6)] bg-[rgba(0,0,0,0.4)]">
                    <SVGPureIcon 
                    name="mindmap_download_v2" 
                    size={24}
                    color={"#ffffff"}
                    />
                </button>
            </Tooltip>
        </div>
    )
})

export default MMDownload;
